const r = {
  parts: ["card", "media", "content"],
  baseStyle: ({ theme: e }) => ({
    card: {
      display: "flex",
      flexDirection: "column",
      border: `${e.cardBorderStyle.width} ${e.cardBorderStyle.style} ${e.cardBorderStyle.color}`,
      height: "100%"
    },
    media: {
      display: "flex",
      img: {
        objectFit: "cover"
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flexGrow: "1",
      "a.cta-link": {
        textDecoration: "underline"
      },
      "& * a.cta-link:hover": {
        textDecoration: "none",
        color: e.action.primaryHover
      }
    }
  }),
  variants: {
    horizontal: ({ theme: e }) => ({
      card: {
        flexDirection: "row",
        maxW: "100%",
        minW: e.localTokens.navTileContainerWidth,
        borderRadius: e.cardHorizontalBorderRadius
      },
      media: {
        h: "100%",
        objectFit: "cover",
        flex: {
          base: 1,
          sm: 5,
          lg: 2
        }
      },
      content: {
        flex: {
          base: 1,
          sm: 3,
          lg: 3
        }
      }
    }),
    short: ({ theme: e }) => ({
      card: {
        flexDirection: "row",
        maxW: "100%",
        minW: e.localTokens.navTileContainerWidth,
        borderRadius: e.cardHorizontalBorderRadius
      },
      media: {
        h: "100%",
        objectFit: "cover",
        flex: {
          base: 1,
          sm: 5,
          lg: 2
        }
      },
      content: {
        flex: {
          base: 1,
          sm: 3,
          lg: 3
        }
      }
    }),
    vertical: ({ theme: e }) => ({
      card: {
        flexDirection: "column",
        flex: 1,
        borderRadius: e.cardVerticalBorderRadius
      },
      media: {
        w: "100%",
        objectFit: "cover"
      }
    })
  },
  defaultProps: {
    variant: "vertical"
  }
};
export {
  r as default
};
